import { createContext, useContext, type ReactNode } from "react"

// Holds the element overlays should portal into. Inside a widget this is the
// shadow-root wrapper so dialogs/popovers/etc. stay inside the shadow tree and
// remain styled. Outside a widget (the SPA) it is null and overlays fall back
// to document.body as usual.
const PortalContainerContext = createContext<HTMLElement | null>(null)

export function PortalContainerProvider({
  container,
  children,
}: {
  container: HTMLElement | null
  children: ReactNode
}) {
  return (
    <PortalContainerContext.Provider value={container}>
      {children}
    </PortalContainerContext.Provider>
  )
}

// Returns undefined (not null) when there is no container so it can be spread
// straight into base-ui/vaul `container` props without overriding their
// document.body default.
// eslint-disable-next-line react-refresh/only-export-components
export function usePortalContainer(): HTMLElement | undefined {
  return useContext(PortalContainerContext) ?? undefined
}
